import { RouteType } from "types/RouteType";
import { RootStore } from "@intrasync/stores";
import MMLoadStore from "stores/millermize/MMLoadStore";

/**
 * The administration side of a job (2026-10-16 items 5–7).
 *
 * Creede: "blending our production and administration would be an issue
 * because the administrators are billing lady, Stephen. They don't need to mess
 * with the tickets or forms or anchors. But it can be a similar build out to
 * this page where I've got some tabs. And I'm able to go through all my jobs
 * here." So: its own page, built like Production -- a job picker and tabs --
 * holding Project Info, D&E and Billing.
 */
const administrationRoute: RouteType = {
  name: "MM Administration",
  path: "/mm/administration",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Administration",
      component: () => import("./Administration.Header"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./Administration.Body"),
      grayBackground: true,
    },
  },
  group: "Miller-Mize",
  menuOrder: 2,
  requiresAuth: true,
  requiresPermission: false,
  dialogs: [
    // The same form as the Projects page: one place to edit a job, not two.
    {
      name: "Edit Project",
      title: "Edit Project",
      height: 600,
      component: () => import("../ProjectInfo/ProjectInfoDialogs/ProjectFormDialog"),
    },
  ],
  // Billing is read from loads, so re-read them on the way in (the same
  // "slow refresh" reason as Production). Fire-and-forget; never blocks.
  beforeEnter: async ({
    rootStore,
    manualTrigger,
  }: {
    rootStore: RootStore;
    manualTrigger?: boolean;
  }) => {
    const loads = rootStore.mmLoadStore as MMLoadStore | undefined;
    void loads?.refresh({ force: !!manualTrigger });
    return true;
  },
};

export default administrationRoute;
